import { useSnackbar } from 'notistack'
import React from 'react'



const InnerSnackbarUtilsConfigurator = (props) => {
    props.setUseSnackbarRef(useSnackbar())
    return null;
}

let useSnackbarRef;
const setUseSnackbarRef = (useSnackbarRefProp) => {
    useSnackbarRef = useSnackbarRefProp
}

export const SnackbarUtilsConfigurator = () => {
    return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
}

export const snackActions = {
    snackBar(params) {
        useSnackbarRef.enqueueSnackbar(params?.message ?? '', { ...params?.options ?? { variant: 'error' } })
    },
    snackBarComponent(mess, variant) {
        useSnackbarRef.enqueueSnackbar(mess || '', { variant: variant || 'error' })
    }
}